import { useEffect } from 'react';
import { initCountdown, reset, start, tick } from 'src/store/slices/countDownSlice';
import { useAppSelector, useAppDispatch } from 'src/store';

export function useCountDown(
  durationSeconds: number,
  storageKey = 'init_countdown',
  timeFormat: string | null = null,
) {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.countDownSlice);
  const { remaining, formatted, isRunning } = state[storageKey] || {};
  const startFn = () => {
    dispatch(start({ storageKey }));
  };

  useEffect(() => {
    dispatch(initCountdown({ durationSeconds, storageKey, format: timeFormat }));
  }, [dispatch, durationSeconds, storageKey, startFn]);

  useEffect(() => {
    if (!isRunning) return;
    const interval = setInterval(() => {
      dispatch(tick({ storageKey }));
    }, 1000);
    return () => clearInterval(interval);
  }, [dispatch, isRunning, storageKey, startFn]);

  return {
    remaining,
    formatted,
    isRunning,
    start: startFn,
    reset: () => dispatch(reset({ storageKey })),
  };
}
